module.exports = __webpack_public_path__ + "img/footer.4c74cbdf.jpg";